
import React, { Suspense, useState, useEffect, useRef } from "react";
import ReactDatePicker from "react-datepicker";
import Drawer from 'react-modern-drawer';
import DatePickerRange from "../../PeriodSelection/DatePickerRange";
import { format } from "date-fns";

export default function NewSongs(param :any ) {

    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    }

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(1);

    const dateSelection =(e :any) =>{
        if(e !== null){

            if(e[0] !== null){
                console.log( format(new Date(e[0]), 'yyyyMMdd') )
            }

            if(e[1] !== null ){
                console.log( format(new Date(e[1]), 'yyyyMMdd') )
            }
        }
    }

    return (
        <div>
            <button className='icon-btn edit pull-right ml' onClick={() => {setIsOpen(!isOpen)} }>
                <i className="icon-file-add"></i> Add New Songs
            </button>

            <Drawer open={isOpen}
                    onClose={toggleDrawer}
                    direction='right'
                    className='react-drawer'
                    size={1300}>

                <div className="box">                        

                    <div className="box-header ws-12">
                        <h2><i className="icon-edit"></i> Song Details</h2>

                        <ul className="nav nav-tabs">
                            <li className={showtab === 1 ?"bgWhite active btn-l":"bgWhite btn-l"} onClick={() => (setShowTab(1) ,setShowSubTab(1))}><a >Song Details</a></li>
                            <li className={showtab === 2 ?"bgWhite active btn-l":"bgWhite btn-l"} onClick={() => (setShowTab(2) ,setShowSubTab(4))}><a >Song Additional Details</a></li>
                            <li className="hide"><a >Alternative Titles</a></li>
                            <li className="hide"><a >Performing Artist</a></li>
                            <li className="hide"><a >Recording Details</a></li>
                            <li className="hide"><a >Work Origin</a></li>
                            <li className="hide"><a >Versions andExcerpts</a></li>
                        </ul>
                    </div>

                    <div className="box-content ws-12">
                        
                        <div className="form-format ws-12 m0"> 
                            <div className="ws-12">
                                <div className="ws-6"> &nbsp;</div>
                                <div className="ws-6">
                                    <ul className="nav nav-tabs ps pl">
                                        <div className={(showtab==1)?"":"hide"}>
                                        <li className={showSubtab==1?"btn-l active":"btn-l"} onClick={() => setShowSubTab(1)}><a>Class</a></li>
                                        <li className={showSubtab==2?"btn-l active":"btn-l"} onClick={() => setShowSubTab(2)}><a>Copyright</a></li>
                                        <li className={showSubtab==3?"btn-l active":"btn-l"} onClick={() => setShowSubTab(3)}><a>Status</a></li></div>

                                        <div className={(showtab==2)?"":"hide"}>
                                        <li className={(showSubtab==4)?"btn-l active":"btn-l"} onClick={() => setShowSubTab(4)}><a>Details</a></li>
                                        <li className={(showSubtab==5)?"btn-l active":"btn-l"} onClick={() => setShowSubTab(5)}><a>Version</a></li></div>
                                    </ul>
                                </div>

                            </div>

                        </div>

                        <div className="ws-6 pr">
                            <fieldset className="scheduler-border">
                                <legend className="scheduler-border">
                                    <h2><i className="fa fa-sticky-note-o"></i> Song Info</h2>
                                </legend>
                                <form className="form-horizontal form-condensed  row-fluid" name="songform">
                                    <div className="ws-12">
                                        <div className="ws-6">
                                            <div className={(showtab==1)?"":"hide"}>
                                                <div className="form-format m0 mtl">
                                                    <label className="control-label ">Song Ref*</label>
                                                    <div className="label-entries"><input type="text" name="songRef" className="form-control" placeholder="Song Ref" /></div>
                                                </div>

                                                <div className="form-format m0 mtl hide">
                                                    <label className="control-label ">SongID</label>
                                                    <div className="label-entries"><input type="text" name="songID" className="form-control "/></div>
                                                </div>

                                                <div className="form-format m0 mtl">
                                                    <label className="control-label">ISWC*</label>
                                                    <div className="label-entries"><input type="text" name="intStdWorkCode" className="form-control" placeholder="ISWC"/></div>
                                                </div>

                                                <div className="form-format m0 mtl">
                                                    <label className="control-label ">Song Title*</label>
                                                    <div className="label-entries">
                                                        <input type="text" name="songTitle" className="form-control" placeholder="Song Title"/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={(showtab==2)?"":"hide"}>                                           
                                                    <div className="form-format m0 mtl">
                                                        <label className="control-label ">CWR Distribution Code</label>
                                                        <div className="label-entries">
                                                            <select  name="songCWRDistribution" className="ws-11">
                                                                <option value=""> Choose CWR Distribution Code</option>
                                                                <option value="0" label="Jazz">Jazz</option>
                                                                <option value="1" label="Popular">Popular</option>
                                                                <option value="2" label="Serious">Serious</option>
                                                                <option value="3" label="UnclassNameified Distribution Category">UnclassNameified Distribution Category</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="form-format m0 mtl">
                                                        <label className="control-label ">Music or Lyrics</label>
                                                        <div className="label-entries">
                                                            <select  name="songMusicOrText" className="ws-11">
                                                                <option value=""> Choose Music or Lyrics</option>
                                                                <option value="0" label="Music">Music</option>
                                                                <option value="1" label="Music and Text">Music and Text</option>
                                                                <option value="2" label="Text">Text</option>
                                                                <option value="3" label=""> </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="form-format m0 mtl">
                                                        <label className="control-label" >Composite Type</label>
                                                        <div className="label-entries">
                                                            <select name="songCWRComposite" className="ws-11">
                                                                <option value=""> Choose Composite Type</option>
                                                                <option value="0" label="Composite of Samples">Composite of Samples</option>
                                                                <option value="1" label="Medley">Medley</option>
                                                                <option value="2" label="Potpourri">Potpourri</option>
                                                                <option value="3" label="Unspecified Composite">Unspecified Composite</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                            </div>

                                        </div>
                                        <div className="ws-6">

                                            <div className={(showtab==1)?"":"hide"}>
                                                <div className="form-format m0 mtl">
                                                    <label className="control-label ">Song Main Publisher</label>
                                                    <div className="label-entries"><input type="text" name="songName" className="form-control" placeholder="Song Main Publisher" /></div>
                                                </div>

                                                <div className="form-format m0 mtl">
                                                    <label className="control-label ">Song Main Composer</label>
                                                    <div className="label-entries"><input type="text" name="songName" className="form-control" placeholder="Song Main Composer"/></div>
                                                </div>
                                                <div className="form-format m0 mtl hide">
                                                    <label className="control-label ">Song Main Lyricist </label>
                                                    <div className="label-entries">
                                                        <div className="input-group">
                                                            <input type="text" className="form-control text-uppercase" placeholder="Song Main Lyricist" name="songMainLyricist" />
                                                            <span className="input-group-btn"><button type="button" className="icon-btn edit" ><i className="icon-user-add"></i></button></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-format m0 mtl hide">
                                                    <label className="control-label ">Song Conductor</label>
                                                    <div className="label-entries">
                                                        <div className="input-group">
                                                            <input type="text" className="form-control text-uppercase " placeholder="Song Conductor" name="songConductor"/>
                                                            <span className="input-group-btn"><button type="button" className="icon-btn edit"><i className="icon-user-add"></i></button></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-format m0 mtl">
                                                    <label className="control-label ">Title Version</label>
                                                    <div className="label-entries"><input type="text" name="titleVersion" className="form-control" placeholder="Title Version" /></div>
                                                </div>
                                            </div>


                                            <div  className={(showtab==2)?"":"hide"}>
                                                <div className="form-format m0 mtxl">
                                                    <label className="control-label " >Music Arrangement</label>
                                                    <div className="label-entries">
                                                        <select  name="songCWRArrangementType" className="ws-11">
                                                            <option value="" > Choose Music Arrangement</option>
                                                            <option value="0" label="New">New</option>
                                                            <option value="1" label="Arrangement">Arrangement</option>
                                                            <option value="2" label="Addition">Addition</option>
                                                            <option value="3" label="Unspecified arrangement">Unspecified arrangement</option>
                                                            <option value="4" label="Original">Original</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="form-format m0 mtl">
                                                    <label className="control-label " >Lyric Adaption</label>
                                                    <div className="label-entries">
                                                        <select name="songCWRLyricType" className="ws-11">
                                                            <option value="" > Choose Lyric Adaption</option>
                                                            <option value="0" label="New">New</option>
                                                            <option value="1" label="Modification">Modification</option>
                                                            <option value="2" label="None">None</option>
                                                            <option value="3" label="Original">Original</option>
                                                            <option value="4" label="Replacement  L">Replacement  L</option>
                                                            <option value="5" label="Addition">Addition</option>
                                                            <option value="6" label="Unspecified">Unspecified</option>
                                                            <option value="7" label="Translation">Translation</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="form-format m0 mtl">
                                                    <label className="control-label " >Work Type</label>
                                                    <div className="label-entries">
                                                        <select name="songCWRWorkType" className="ws-11">
                                                            <option value=""> Choose Work Type</option>
                                                            <option value="0" label="AAA (Triple A)">AAA (Triple A)</option>
                                                            <option value="1" label="Adult Contemporary">Adult Contemporary</option>
                                                            <option value="2" label="Album Oriented Rock (AOR)">Album Oriented Rock (AOR)</option>
                                                            <option value="3" label="Alternative Music">Alternative Music</option>
                                                            <option value="4" label="Americana">Americana</option>
                                                            <option value="5" label="Band">Band</option><option value="6" label="Bluegrass Music">Bluegrass Music</option>
                                                            <option value="7" label="Children’s Music">Children’s Music</option>
                                                            <option value="8" label="Classical Music">Classical Music</option>
                                                            <option value="9" label="Contemporary Christian">Contemporary Christian</option>
                                                            <option value="10" label="Country Music">Country Music</option>
                                                            <option value="11" label="Dance">Dance</option>
                                                            <option value="12" label="Film/ Television Music">Film/ Television Music</option>
                                                            <option value="13" label="Folk Music">Folk Music</option>
                                                            <option value="14" label="Gospel (Black)">Gospel (Black)</option>
                                                            <option value="15" label="Gospel (Southern)">Gospel (Southern)</option>
                                                            <option value="16" label="Jazz Music">Jazz Music</option>
                                                            <option value="17" label="Jingles">Jingles</option>
                                                            <option value="18" label="Latin">Latin</option>
                                                            <option value="19" label="Latina">Latina</option>
                                                            <option value="20" label="New Age">New Age</option>
                                                            <option value="21" label="Opera">Opera</option>
                                                            <option value="22" label="Polka Music">Polka Music</option>
                                                            <option value="23" label="Pop Music">Pop Music</option>
                                                            <option value="24" label="Rap Music">Rap Music</option>
                                                            <option value="25" label="Rock Music">Rock Music</option>
                                                            <option value="26" label="Rhythm and Blues">Rhythm and Blues</option>
                                                            <option value="27" label="Sacred">Sacred</option>
                                                            <option value="28" label="Symphonic">Symphonic</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </fieldset>
                        </div>

                        <div className="ws-6 pr">

                            <fieldset className="scheduler-border " >
                                <legend className="scheduler-border">
                                    <h2><i className="fa fa-sticky-note-o"></i> className </h2>
                                </legend>

                                <div className={showSubtab==1?"ws-12":"ws-12 hide"}>
                                    <div className="ws-6">
                                        <div className="form-format m0 mtl hide">
                                            <label className="control-label ">Production Name</label>
                                            <div className="label-entries">
                                                <input type="text" name="productionName" className="form-control " placeholder="Production Name" />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl hide" >
                                            <label className="control-label ">Controlled %</label>
                                                <div className="label-entries">
                                                    <input type="text" name="controlledPercentage" className="form-control " placeholder="Controlled %"/>
                                                </div>
                                            </div>
                                    </div>

                                    <div className="ws-6">
                                        <div className="form-format m0 mtl">
                                            <label className="control-label " >DIM 1</label>
                                             <div className="label-entries"><input type="text" placeholder="Enter DIM 1" name="catCoMedia" /></div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">DIM 2</label>

                                            <div className="label-entries">
                                                <input type="text" placeholder="Enter DIM 2" className="form-control"  id="frmformatListing.analysisDiM2" name="catCoMediaCode"/>
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">DIM 3</label>

                                            <div className="label-entries">
                                                <input type="text" placeholder="Enter DIM 3" className="form-control "  id="frmformatListing.analysisDIM3" name="analysisDIM3"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={showSubtab==2?"ws-12":"ws-12 hide"}>
                                    <div className="ws-6">
                                        <div className="form-format m0 mtl ">
                                            <label className="control-label ">Copyright Number</label>
                                            <div className="label-entries">
                                                <input type="text" name="songCYear" className="form-control " placeholder="Copyright Number" />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl " >
                                            <label className="control-label ">Copyright Date</label>
                                            <div className="label-entries">
                                                <input type="text" name="songCHolder" className="form-control " placeholder="Copyright Date"/>
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl " >
                                            <label className="control-label ">Genre</label>
                                            <div className="label-entries">
                                                <input type="text" name="songGenre" className="form-control " placeholder="Genre"/>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="ws-6">
                                        <div className="form-format m0 mtl">
                                            <label className="control-label " >Mood</label>
                                             <div className="label-entries"><input type="text" placeholder="Mood" name="mood" /></div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">ERA</label>

                                            <div className="label-entries">
                                                <input type="text" placeholder="ERA" className="form-control"  name="eRA"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className={showSubtab==3?"ws-12":"ws-12 hide"}>
                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Song Status</label>
                                        <div className="label-entries">
                                            <select name="songStatus" className="full-width">
                                                <option value="">Choose Status</option>
                                                <option value="0" label="Released">Released</option>
                                                <option value="1" label="Not Released">Not Released</option>
                                                <option value="2" label="Never Released">Never Released</option>
                                                <option value="3" label="Sold">Sold</option>
                                                <option value="4" label="In Set-up">In Set-up</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-format m0 mtl">
                                        <label className="control-label ">Extended Status</label>
                                        <div className="label-entries">
                                            <select name="songStatusSplits" className="full-width">
                                                <option value="">Choose Status</option>
                                                <option value="0" label="Released">Released</option>
                                                <option value="1" label="Never Released">Never Released</option>
                                                <option value="2" label="Not Released">Not Released</option>
                                                <option value="3" label="Sold">Sold</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className={showSubtab==4?"ws-12":"ws-12 hide"}>
                                    <div className="ws-6">

                                        <div className="form-format m0 mtl">
                                            <label className="control-label " >Song Duration</label>
                                            <div className="label-entries">
                                                <input type="text" name="intStdWorkCode" className="form-control " placeholder="Song Duration"/>
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">
                                                Composite
                                                Count
                                            </label>
                                            <div className="label-entries">
                                                <input type="text" name="songCWRCompositeCount" className="form-control " placeholder="Composite Count" />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label">Publication Date</label>

                                            <DatePickerRange onChange={dateSelection} type={"icon"}/>
                                        </div>
                                    </div>

                                    <div className="ws-6">
                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">Exception Clause</label>
                                            <div className="label-entries">
                                                <input type="text" name="songCWRExceptionalClause" className="form-control " placeholder="Exception Clause" />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label ">OPUSNumber</label>
                                            <div className="label-entries">
                                                <input type="text" name="songCWROPUSNumber" className="form-control " placeholder="OPUS Number" />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mt">
                                            <label className="control-label ">Catalogue Number</label>
                                            <div className="label-entries">
                                                <input type="text" name="songCWRCatlognumber" className="form-control " placeholder="Catalogue Number" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={showSubtab==5?"ws-12":"ws-12 hide"}>
                                    <div className="ws-6">                                    
                                        <div className="form-format m0 mtl">
                                            <label className="control-label w-35">Version Types</label>
                                            <div className="label-entries w-60">
                                                <div className="ws-5"><input type="radio" name="songCWRVersionType" className="form-control " value="0" placeholder="Song Duration"/>ORI</div>
                                                <div className="ws-5"><input type="radio" name="songCWRVersionType" className="form-control " value="1" placeholder="Song Duration"/>MOD</div>
                                            </div>
                                        </div>
                                            
                                        <div className="form-format m0 mtl">
                                            <label className="control-label w-35">Excerpt Type</label>
                                            <div className="label-entries w-60">
                                                <div className="ws-5"><input type="radio" name="songCWRExcerptType" className="form-control " value="0" />Blank</div>
                                                <div className="ws-5"><input type="radio" name="songCWRExcerptType" className="form-control " value="1" /> UEX</div>
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl">
                                            <label className="control-label w-35 ">Grand Rights</label>
                                            <div className="label-entries w-60">
                                                <div className="ws-5"><input type="radio" name="songCWRGrandRights" className="form-control " value="0" />Yes</div>
                                                <div className="ws-5"><input type="radio" name="songCWRGrandRights" className="form-control " value="1" />No</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ws-6">
                                        <div className="form-format m0 mtl">
                                            <label className="control-label ws-6"> Recorded</label>
                                            <div className="label-entries ws-6">
                                                <input type="checkbox" className="checkbox-inline m0 ml " />
                                            </div>
                                        </div>

                                        <div className="form-format m0 mtl ws-12">
                                            <label className="control-label ws-5"> Priority Flag </label>
                                            <div className="label-entries ws-6">
                                                <div className="ws-5"> <input type="radio" name="songCWRPriorityFlag" className="form-control" value="0" /> Yes </div>
                                                <div className="ws-5"> <input type="radio" name="songCWRPriorityFlag" className="form-control" value="1" />No </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                               
                            </fieldset>
                        </div>

                    </div> 

                    <div className="box-footer mb mr">
                        <button className="icon-btn edit btn-sm pull-right hide" ><i className="fa fa-save"></i> reset</button>
                        <button className="icon-btn delete btn-sm pull-right" onClick={ () => setIsOpen(false)}><i className="fa fa-close"></i> Close</button>
                        <button className="icon-btn edit btn-sm pull-right" onClick={ () => setIsOpen(false)}><i className="fa fa-close"></i> Save</button>
                    </div>   
                </div>              
            </Drawer>
            
        </div>
    )
}